const topbar = document.querySelector('.dke_topbar');
const navbarMenu = document.querySelector('.dke_navbar__menu');

export function navbarHead() {
  if (navbarMenu && topbar) {
    const topbarHeight = topbar.offsetHeight;
    window.addEventListener('scroll', hiddenSubtextNavbar.bind(null, topbarHeight));
  }
}

// скрываемт часть текста пункта меню после прокручивания topbar-а
function hiddenSubtextNavbar(topbarHeight) {
  const scrollTop = document.documentElement.scrollTop;
  
  if (scrollTop > topbarHeight + 30) {
    navbarMenu.classList.add('js_dke_hidden');
  } 
  if (scrollTop <= topbarHeight){
    navbarMenu.classList.remove('js_dke_hidden');
  }
}
